import React from 'react';
import clsx from "clsx";
import {Card, CardContent, CardHeader, Paper, Typography} from "@mui/material";
import {useTheme} from "@mui/styles";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {lightBlue, orange} from "@mui/material/colors";
import moment from "moment";
import {formatText} from "../../../widgets/chat/ChatFab";

const HistoryCard = ({storico, quarantena}) => {
	const theme = useTheme();
	const classes = BaseStyle();
	
	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Storico note</b></Typography>}
				/>
				<CardContent style={{flexGrow: 1}}>
					{
						storico
							.filter(stoElem => !stoElem.lastModify.includes("AUTODUMP"))
							.sort((a, b) => new Date(b.dataModifica) - new Date(a.dataModifica))
							.map((item, index) => {
								return (
									<Paper elevation={0} key={index} id={"paper-storico" + index}
									       style={{
										       backgroundColor: theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800],
										       borderRadius: 24,
										       padding: 16,
										       marginRight: 100,
										       marginTop: 16
									       }}>
										<Typography variant={"subtitle2"} color={"textSecondary"}>
											<b>{item.lastModify}</b> ha scritto in
											data: {moment(item.dataModifica).format("DD/MM/YYYY - HH:mm")}
										</Typography>
										<Typography variant={"subtitle1"}>
											{
												item.note?.includes("DTO") ? transformDTOtoReadableString(item.note) : formatText(item.note)
											}
										</Typography>
									</Paper>
								)
							})
					}
					<Paper elevation={0}
					       style={{
						       backgroundColor: theme.palette.mode === "light" ? orange[50] : orange[800],
						       borderRadius: 24,
						       padding: 16,
						       marginLeft: 100,
						       marginTop: 16
					       }}>
						<Typography variant={"subtitle2"} color={"textSecondary"}>
							<b>Il paziente</b> ha scritto in
							data: {moment(quarantena?.dataCreazione).format("DD/MM/YYYY - HH:mm")}
						</Typography>
						<Typography variant={"subtitle1"}>
							{
								(quarantena.note && quarantena.note.replaceAll(/#(\S*)/g, "").replaceAll(" ", "").length > 0) ?
									quarantena.note.replaceAll(/#(\S*)/g, "") : <i>Non sono presenti note...</i>
							}
						</Typography>
					</Paper>
				</CardContent>
			</Card>
        </React.Fragment>
    );
};

export function transformDTOtoReadableString(stringDTO) {
	let step1 = stringDTO.replaceAll("QuarantenaDTO", "").replaceAll("(", "").replaceAll(")", "").replaceAll("AnagraficaDTO", "");
	let step2 = step1.split(",")
	let step3 = step2.filter(i => !i.includes("hash") && !i.includes("id"))
	
	return <ul>
		<li>{step3[0]}</li>
		<li>{step3[1]}</li>
		<li>{step3[2]}</li>
		<li>{step3[3]}</li>
		<li>{step3[4]}</li>
		<li>{step3[5]}</li>
		<li>{step3[6]}</li>
		<li>{step3[7]}</li>
		<li>{step3[8]}</li>
		<li>{step3[9]}</li>
		<li>{step3[10] === "note=" ? "non sono presenti note" : step3[10]}</li>
		<li>{step3[14].replace("codF", "Codice fiscale")}</li>
	</ul>
}

export default React.memo(HistoryCard);
